export const logger = {
    info: (context, message) => {
        console.log(message, context);
    },
    error: (context, message) => {
        console.error(message, context);
    },
};
export const setLogger = (newLogger) => {
    Object.assign(logger, newLogger);
};
//# sourceMappingURL=log.js.map